import { render, staticRenderFns } from "./ththreshold.vue?vue&type=template&id=131f4433&scoped=true&"
import script from "./ththreshold.vue?vue&type=script&lang=ts&"
export * from "./ththreshold.vue?vue&type=script&lang=ts&"
import style0 from "./ththreshold.vue?vue&type=style&index=0&id=131f4433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f4433",
  null
  
)

export default component.exports